module.exports = __webpack_public_path__ + "img/happy.70db758f.png";